import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advertisementbanner1',
  templateUrl: './advertisementbanner1.component.html',
  styleUrls: ['./advertisementbanner1.component.css']
})
export class Advertisementbanner1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
